/**
 * window.PdLoad — on-demand loading of the storefront's vendored libraries (Swiper, Leaflet,
 * PageFlip…), shared by swiper-init.js, map-init.js and flipbook-init.js.
 *
 *   PdLoad.script(url, isReady?) → Promise, one request per URL; resolves at once when isReady()
 *                                  says the library is already there (another copy loaded it).
 *   PdLoad.css(url)              → adds the stylesheet once.
 */
(function () {
    if (window.PdLoad) return;
    var scripts = {};

    window.PdLoad = {
        script: function (url, isReady) {
            if (scripts[url]) return scripts[url];
            scripts[url] = new Promise(function (resolve, reject) {
                if (isReady && isReady()) { resolve(); return; }
                var s = document.createElement('script');
                s.src = url;
                s.onload = resolve;
                s.onerror = function () { delete scripts[url]; reject(new Error('Failed to load: ' + url)); };
                document.head.appendChild(s);
            });
            return scripts[url];
        },
        css: function (url) {
            if (document.querySelector('link[href="' + url + '"]')) return;
            var link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = url;
            document.head.appendChild(link);
        }
    };
})();
